// extracted by mini-css-extract-plugin
export default {"partners":"Home_partners__gL2B-"};